import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'rmt-labels',
  templateUrl: 'rmt-labels.html'
})
export class RmtLabelsComponent {

  @Input() private labels: LabelItem[];
  @Output() labelTap = new EventEmitter<LabelItem>();

  constructor() {
  }

  onLabelClick(event, label: LabelItem) {
    if (!label || !label.action)
      return;
    event.stopPropagation();
    this.labelTap.emit(label);
  }

  geIconFor(label) {
    if (label.icon === "mega-phone") {
      return "custom-icon-mega-phone";
    }
    else if (label.icon === "star") {
      return "custom-icon-star";
    }
    else if (label.icon === "lightning") {
      return "custom-icon-lightning";
    }
    else if (label.icon === "dollar") {
      return "custom-icon-dollar";
    }
  }

}

export type labelIconType = "star | mega-phone | lightning | dollar"
export type labelClassType = "best-rate | new-rate | fastest-payment-method | lowest-fee-payment-method | expired-card | relink-bank"
export interface LabelItem {
  text: string;
  class: labelClassType,
  icon: labelIconType,
  action?: string;
}


// WEBPACK FOOTER //
// ./src/components/rmt-labels/rmt-labels.ts